<template>
<div style="min-width: 1450px;" id="top">
    <div class="pink_box">
        <h1>More Beny-Ficial, Less Superficial</h1>
        <div class="new_tips">
            To us, doing good means offering ‘work benefits’ that are actually beneficial.
            <p style="height: 11px;width: 100%;"></p>
            It’s not about surface-level-ticking-of-boxes, it’s providing valuable wellbeing essentials that help your team become the best version of themselves.
        </div>
    </div>
    <div class="benefit-wrap">
        <div class="top_tit">How does Beny bring the big-name benefits on board?</div>
        <ul class="top_ul">
            <li class="item_li">
                <img src="../../assets/home/checked.png" class="check_icon" alt="">
                We bring minority SME organisations together, to become a major collective. 
            </li>
            <li class="item_li">
                <img src="../../assets/home/checked.png" class="check_icon" alt="">
                This gives Beny the power to negotiate and access the best benefits in the market.
            </li>
            <li class="item_li">
                <img src="../../assets/home/checked.png" class="check_icon" alt="">
                The more Beny members, the more Beny-fits unlocked.
            </li>
        </ul>
        <h2>Browse by category:</h2>
        <div class="menu">
            <ul id="navListas2">
                <li :class="{'active':active2 == item.value}"
                v-for="(item,i) in options" :key='i'
                @click="changeType2(item.value, i, $event, item.label)">
                    {{item.label}}
                </li>
                <span ref="bottomSlider"> </span>
            </ul>
        </div>
        <h3>Benefits</h3>
    </div>
    <div class="photos">
        <ul class="clear">
            <li v-for="item in list" :key="item.benefitsId">
                <div class="img" :style="{'backgroundImage': `url(${item.coverImage})`}"></div>
                <p>{{item.benefitsName}}</p>
            </li>
        </ul>
        <div class="page-wrap">
        <el-pagination v-if="!loading"
        class="page-wrap"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="15"
        :pager-count='5'
        layout="prev, pager, next"
        :total="total">
        </el-pagination>
        </div>
    </div>
    <div class="tow-boxs">
        <div class="lft"></div>
        <div class="pink">
            <div class="spaceone"></div>
            <div class="content">
                <h1>Become a Beny<br />organisation</h1>
                <h2>
                    Ready to become fast friends with Beny? Sign up <br />
                    now, quicker than it takes to brew a cup of <br />
                    coffee and give your employees not only access <br />
                    to 1000’s of big-name benefits, but the valuable <br />
                    wellness and wellbeing support that gets them <br />
                    from nine to thrive.
                </h2>
                <div class="button" @click="jump('/registered')">Get started</div>
            </div>
            <div class="spacetow"></div>
            <div class="img"></div>
            <div class="spacethree"></div>
        </div>
        <div class="center"></div>
        <div class="pink">
            <div class="spaceone"></div>
            <div class="content">
                <h1>Become a Beny Partner</h1>
                <h2>
                    Interested in partnering up with Beny for <br />
                    Business? The Beny network spans across <br />
                    thousands of Australian businesses providing an <br />
                    expansive range of B2B products and services. <br />
                    Your organisation can be a part of our circle. <br />
                    Partner with Beny and offer benefits to win <br />
                    more customers.
                </h2>
                <div class="button" @click="jump('/partner')">Become a partner</div>
            </div>
            <div class="spacetow"></div>
            <div class="img2"></div>
            <div class="spacethree"></div>
        </div>
        <div class="rgt"></div>
    </div>
</div>
</template>

<script>
import http from '../../api/benefits.js'
import $ from 'jquery'

export default {
    data () {
        return {
            options: [{
                value: -1,
                label: 'All'
            }],
            active2: -1,
            list: [],
            loading: false,
            page: 1,
            total: 0,
        }
    },
    created () {
        var that = this
        that.getList()
        http.categoryList({
            callback: (res) => {
                if (res.data.code == 200) {
                    res.data.data.forEach(i => {
                        that.options.push({
                            value: i.benefitsCategoryId,
                            label: i.categoryName
                        })
                    })
                } else {
                    Utils.alert('', res.data.message, 'error')
                }
            }
        })
    },
    methods: {
        jump (path) {
            this.$router.push(path)
        },
        // 选择分类
        changeType2(id, i ,el){
            this.active2 = id
            this.navCneter(i,el)
            this.page = 1
            this.getList()
        },
        // 分类剧中
        navCneter(i,el){
            let timer=''
            let target = el ? el.target : this.cateEle[i]
            let currentSliderWidth = target.clientWidth / 2
            // 航条切换居中实现
            let dom = document.getElementById('navListas2')
            let innerWidth = window.innerWidth // 屏幕宽度
            let diffWidth = (innerWidth - target.clientWidth) / 2
            let targetOffset = target.offsetLeft - diffWidth
            clearInterval(timer)
            timer=setTimeout(() => {
                this.$refs.bottomSlider.style.left = target.offsetLeft + currentSliderWidth + 'px'
            }, 50)
            this.$refs.bottomSlider.style.width = (target.clientWidth - 50) + 'px'
            if(targetOffset!==this.left){
                this.left=targetOffset
            }else{
                return
            }
            if (targetOffset < 0) {
               $('#navListas2').animate({scrollLeft:0},500)
                return
            }
            $('#navListas2').animate({scrollLeft:targetOffset},500)
        },
        // 请求数据
        getList() {
            var that = this
            that.list = []
            that.loading = true
            let params = {
                page: that.page
            }
            if (that.active2 !== -1)
                params.benefitsCategoryId = that.active2
            http.benefitslist({
                params: params,
                callback: (res) => {
                    if (res.data.code == 200) {
                        that.loading = false
                        that.list = res.data.data.records
                        that.total = res.data.data.total
                    } else {
                        that.loading = false
                        Utils.alert('', res.data.message, 'error')
                    }
                    document.getElementById('top').scrollIntoView()
                }
            })
        },
        handleCurrentChange(page){
            var that = this
            that.page = page
            that.getList()
        }
    }
}
</script>

<style lang="scss" scope>
.pink_box{
    width: 100%;
    // height: 453px;
    background: #F1DADD;
    h1{
        width: 100%;
        text-align: center;
        font-size: 52px;
        font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
        font-weight: 900;
        color: #3A3835;
        line-height: 67px;
        padding: 120px 0 20px 0;
    }
    .new_tips{
        width: 800px;
        margin: 0 auto;
        text-align: center;
        font-size: 18px;
        font-family: Assistant-Medium, Assistant;
        font-weight: 500;
        color: #3A3835;
        line-height: 21px;
        padding-bottom: 100px;
    }
}
.benefit-wrap{
    width: 100%;
    padding: 100px 150px 0 150px;
    box-sizing: border-box;
    .top_tit{
        width: 100%;
        text-align: center;
        font-size: 40px;
        font-family: Assistant-Bold, Assistant;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 47px;
    }
    .top_ul{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 60px 0 130px 0;
        .item_li{
            width: 360px;
            display: flex;
            align-items: flex-start;
            .check_icon{
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
            font-size: 20px;
            font-family: Lora-Regular, Lora;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 26px;
        }
    }
    h1{
        line-height: 19px;
        color: #fff;
        font-size: 15px;
        font-family: Assistant;
        font-weight: 400;
    }
    h2{
        margin-bottom: 40px;
        font-size: 40px;
        font-family: Assistant;
        font-weight: bold;
        line-height: 56px;
        color: #FFFFFF;
    }
    .menu{
        height: 70px;
        padding-right: 30px;
        box-sizing: border-box;
        position: relative;
        border-bottom: 1px solid #5E5C59;
        margin-bottom: 60px;
        ul{
            display: flex;
            overflow-x: auto;
            white-space: nowrap;
            position: relative;
            &::-webkit-scrollbar{
                width:0px;
                height:0px;
            }
            li{
                margin-right: 31px;
                box-sizing: border-box;
                text-align: center;
                cursor: pointer;
                font-size: 17px;
                font-family: Lora;
                color: #fff;
                line-height: 70px;
                position: relative;
                &.active{
                    color: #F8A4AE;
                }
                &.active:after{
                    content: '';
                    position: absolute;
                    display: block;
                    left: 0;
                    bottom: 1px;
                    border: 1px solid #F8A4AE;
                    width: 100%;
                    z-index: 1;
                }
            }
        }
        .icondown{
            position: absolute;
            top: 0;
            right: 10px;
        }
        .iconup{
            position: absolute;
            bottom: 10px;
            right: 10px;
        }
    }
    h3{
        font-size: 22px;
        font-family: Lora;
        font-weight: normal;
        line-height: 30px;
        color: #FFFFFF;
        margin-bottom: 12px;
    }
}
.photos{
    padding: 0 134px 130px 150px;
    box-sizing: border-box;
    .clear{
        width: 100%;
    }
    .clear li{
        width: 265px;
        float: left;
        margin: 0 15px 20px 0;
        overflow: hidden;
        .img{
            height: 205px;
            border-radius: 8px;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-color: #424140;
            margin-bottom: 9px;
        }
        p{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 17px;
            font-family: Lora;
            font-weight: normal;
            line-height: 24px;
            color: #FFFFFF;
            word-break: break-word;
            min-height: 48px;
        }
    }
}
.tow-boxs{
    width: 100%;
    display: flex;
    flex-direction: row;
    .lft, .rgt{
        width: 40px;
        flex: 0 0 auto;
    }
    .center{
        width: 20px;
        flex: 0 0 auto;
    }
    .pink{
        height: 510px;
        flex: 1;
        background: #F1DADD;
        display: flex;
        flex-direction: row;
        .spaceone, .spacetow{
            flex: 1;
        }
        .spacethree{
            flex: 1;
        }
        .content{
            width: 320px;
            h1{
                padding-top: 60px;
                font-size: 40px;
                font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                color: #3A3835;
                line-height: 48px;
                color: #3A3835;
                margin-bottom: 24px;
                word-break: break-word;
            }
            h2{
                font-size: 16px;
                font-family: Assistant-Medium, Assistant;
                font-weight: 500;
                font-style: normal;
                color: #3A3835;
                line-height: 21px;
                word-break: break-word;
                margin-bottom: 24px;
                min-width: 364px;
            }
            .button{
                width: 222px;
                height: 54px;
                line-height: 54px;
                cursor: pointer;
                background: #F8A4AE;
                border-radius: 4px;
                text-align: center;
                font-size: 17px;
                font-family: Assistant-Bold;
                font-weight: bold;
                color: #3A3835;
            }
        }
        .img{
            width: 326px;
            height: 326px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/92075fac249c4af394b7c251e8411163.png');
            margin-top: 60px;
        }
        .img2{
            width: 326px;
            height: 326px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/015a58311b5f41469cf07ae27c5a814a.png');
            margin-top: 60px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/benefits/benefits.vue